/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Mtmsa_DetailInputs */



/**
* | output |
* | --- |
* | "Support against OCIMF's Marine Terminal Management and Self-Assessment (MTMSA) programme. We help terminal operators assess the management of their marine an..." |
*
* @param {Service_Mtmsa_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_mtmsa_detail = /** @type {((inputs?: Service_Mtmsa_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Mtmsa_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照 OCIMF 海运码头管理与自评估（MTMSA）项目提供支持。我们帮助码头运营方对照 MTMSA 要素评估其海事和码头作业的管理。")
	return /** @type {LocalizedString} */ ("Support against OCIMF's Marine Terminal Management and Self-Assessment (MTMSA) programme. We help terminal operators assess the management of their marine and jetty operations against the MTMSA elements.")
});